/**
 * @voltxampere/ui — 7402 quad NOR TTL variant (Sprint 41-4)
 *
 * Reference: TI SN5402. Engine zero-diff invariant honored —
 * canonical `digital-gate` via schemaType.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { opAmp } from "../op-amp.js";
export const logic7402 = {
    id: "7402",
    nameTr: "7402 (4'lü NOR, DIP-14)",
    nameEn: "7402 (Quad NOR, DIP-14)",
    shortcut: "U",
    category: "active",
    viewBox: opAmp.viewBox,
    terminals: opAmp.terminals,
    defaultLabel: "U",
    defaultValue: "7402",
    schemaType: "digital-gate",
    defaultParams: {
        gateFunction: "NOR",
        vHigh: 2.4,
        vLow: 0.4,
        threshold: 1.4,
        propagationDelay: 10e-9,
    },
    renderSVG: () => opAmp.renderSVG(),
};
//# sourceMappingURL=logic-7402.js.map